var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!../../string-replace-webpack-plugin/loader.js?id=ygg9q74r7h!./VueGoogleAutocomplete.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-548d2db4\",\"hasScoped\":false}!../../vue-loader/lib/selector?type=template&index=0!../../string-replace-webpack-plugin/loader.js?id=ygg9q74r7h!./VueGoogleAutocomplete.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-google-autocomplete/src/VueGoogleAutocomplete.vue
// module id = 421
// module chunks = 2